const SIDEBAR_WIDTH_KEY = 'page-sidebar-width';
const DEFAULT_SIDEBAR_WIDTH = 280;

export function getStoredSidebarWidth() {
  const stored = localStorage.getItem(SIDEBAR_WIDTH_KEY);
  const parsed = stored ? parseInt(stored, 10) : DEFAULT_SIDEBAR_WIDTH;
  return Number.isFinite(parsed) ? parsed : DEFAULT_SIDEBAR_WIDTH;
}

export function setStoredSidebarWidth(width) {
  localStorage.setItem(SIDEBAR_WIDTH_KEY, String(width));
}

export function getDeviceType() {
  const width = window.innerWidth;
  if (width > 768) return 'desktop';
  if (width > 480) return 'tablet';
  return 'mobile';
}

export function getResponsiveSidebarWidth() {
  const width = window.innerWidth;
  if (width > 768) return getStoredSidebarWidth();
  if (width > 480) return 220;
  return '100%';
}

export function clampSidebarWidth(width, deviceType = getDeviceType()) {
  if (deviceType === 'desktop') return Math.max(200, Math.min(500, width));
  if (deviceType === 'tablet') return Math.max(180, Math.min(400, width));
  return width;
}
